import {
  formatFileSize,
  toAbsolutePublicUrl,
} from "../../../services/mediaLibraryServices";

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function ensureArray(value) {
  return Array.isArray(value) ? value : [];
}

export function normalizeSearchText(value = "") {
  return String(value || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

export function parseDate(value) {
  if (!value) return null;

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value) {
  const date = parseDate(value);
  if (!date) return "";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export function getYear(value) {
  const date = parseDate(value);
  return date ? String(date.getFullYear()) : "";
}

export function getDocumentTitle(item) {
  return item?.title || item?.original_name || item?.file_name || "Document PDF";
}

export function getDocumentUrl(item) {
  if (!item?.url) return "";
  return toAbsolutePublicUrl(item.url);
}

export function getDocumentDownloadName(item) {
  return item?.original_name || item?.file_name || "document.pdf";
}

export function uniqueById(items = []) {
  const map = new Map();

  items.forEach((item) => {
    if (item?.id) map.set(item.id, item);
  });

  return Array.from(map.values());
}

export function normalizeDocument(item) {
  const title = getDocumentTitle(item);
  const createdAt = item?.created_at || item?.createdAt || "";
  const dateLabel = formatDate(createdAt);
  const year = getYear(createdAt);
  const category = String(item?.category || "").trim();
  const tags = String(item?.tags || "").trim();
  const fileSize = item?.size_bytes ? formatFileSize(item.size_bytes) : "";

  const normalized = {
    id: item?.id,
    raw: item,

    title,
    category,
    tags,

    originalName: item?.original_name || "",
    fileName: item?.file_name || "",
    altText: item?.alt_text || "",

    createdAt,
    dateLabel,
    year,

    url: getDocumentUrl(item),
    downloadName: getDocumentDownloadName(item),

    sizeBytes: item?.size_bytes || null,
    fileSize,
  };

  normalized.searchIndex = normalizeSearchText(
    [
      normalized.title,
      normalized.category,
      normalized.tags,
      normalized.originalName,
      normalized.fileName,
      normalized.altText,
      normalized.dateLabel,
      normalized.year,
    ]
      .filter(Boolean)
      .join(" ")
  );

  return normalized;
}

export function sortDocuments(items, sort, dir) {
  const direction = dir === "ASC" ? 1 : -1;

  return [...items].sort((a, b) => {
    if (sort === "title") {
      return (
        normalizeSearchText(a.title).localeCompare(
          normalizeSearchText(b.title),
          "fr"
        ) * direction
      );
    }

    if (sort === "category") {
      return (
        normalizeSearchText(a.category).localeCompare(
          normalizeSearchText(b.category),
          "fr"
        ) * direction
      );
    }

    const dateA = parseDate(a.createdAt)?.getTime() || 0;
    const dateB = parseDate(b.createdAt)?.getTime() || 0;

    return (dateA - dateB) * direction;
  });
}